// extracted by mini-css-extract-plugin
export var backupIcon = "_s7-1";
export var image = "_s7-0";